import { React, Link, Session, Loader, Helper, Pagination } from "../../../cIncludes";
import { SetProfileStatus } from "../../../services/usersApi";
import { Get as GetStatusList } from "../../../services/statuslistApi";
import { GetUsers } from "../../../services/adminApi";

const RenderPersonaListComponent = () => {
  const [initlized, setInitlized] = React.useState(false);
  const [progress, setProgress] = React.useState(false);
  const [listItems, setListItems] = React.useState([]);
  const [filterItems, setFilterItems] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [statustypes, setStatusTypes] = React.useState([]);

  const [refresh, setRefresh] = React.useState(false);

  const [doSearch, setDoSearch] = React.useState(false);
  const [showFilter, setShowFilters] = React.useState(false);
  const [filtername, setFilterName] = React.useState(null);
  const [search, setSearch] = React.useState({});

  const PageSize = 10;

  React.useEffect(() => {
    setInitlized(true);
  }, []);

  const FetchResults = async () => {
    setProgress(true);
    let rslt = await GetStatusList();
    if (rslt.status === 100) {
      setStatusTypes(rslt.data);
    }
    await LoadUsers();
    setProgress(false);
  };

  const LoadUsers = async () => {
    let rslt = await GetUsers(1);
    if (rslt.status === 100) {
      setListItems(rslt.data);
      OnAddPaging(rslt.data);
    }
  };

  if (initlized) {
    setInitlized(false);
    FetchResults();
  }

  const OnPageChanged = (start, end) => {
    let tmp = filterItems.slice(start, end);
    setRows(tmp);
  };

  const OnDisableClicked = async (id, statusid) => {
    let data = {
      id: id,
      statusid: statusid === 1 || statusid === 3 ? 2 : 1,
    };

    setProgress(true);
    let rslt = await SetProfileStatus(data);
    if (rslt.status === 100) {
      await LoadUsers();
    }
    setProgress(false);
  };

  const RenderButtonControl = (x) => {
    if (x.statusid === 1) {
      return (
        <Link
          to="#"
          title="Disable"
          onClick={(e) => OnDisableClicked(x.id, x.statusid)}
        >
          <div className="enableicon"></div>
        </Link>
      );
    } else if (x.statusid === 2) {
      return (
        <Link
          to="#"
          title="Enable"
          onClick={(e) => OnDisableClicked(x.id, x.statusid)}
        >
          <div className="disableicon"></div>
        </Link>
      );
    } else {
      return (
        <Link
          to="#"
          title="Disable"
          onClick={(e) => OnDisableClicked(x.id, x.statusid)}
        >
          <div className="disableicon"></div>
        </Link>
      );
    }
  };

  const OnSearchInputChanged = (name, val) => {
    setSearch((prev) => ({
      ...prev,
      [name]: val,
    }));
    if (name === "filter") {
      setDoSearch(true);
    }
  };

  const SearchByName = (x, s) => {
    let _name = Helper.GetStringJoin(x, ["first_name", "last_name", "display_name"]);
    return _name.toUpperCase().indexOf(s.toUpperCase()) > -1;
  }

  const OnFilterItems = () => {
    let items = listItems;
    let filterby = Helper.ToInteger(search.filter, 0);
    let searchby = Helper.ToString(search.name);

    if (!Helper.IsNullValue(searchby)) {
      items = items.filter((x) => SearchByName(x, searchby));
    }

    if (parseInt(filterby) > 0) {
      items = items.filter((x) => parseInt(x.statusid) === parseInt(filterby));
      let tmpFilter = statustypes.filter(
        (x) => parseInt(x.id) === parseInt(filterby)
      );
      if (tmpFilter && tmpFilter.length > 0) {
        setFilterName(tmpFilter[0].name);
      }
    }

    OnAddPaging(items);
    setShowFilters(!Helper.IsNullValue(searchby) || parseInt(filterby) > 0);
  };

  const OnAddPaging = (items) => {
    Session.Store("CurrentPage", 1);
    Session.Store("RowsCount", items.length);
    setFilterItems(items);
    setRefresh(!refresh);
    setRows(items.slice(0, PageSize));
  };

  const onSearchClicked = async () => {
    setDoSearch(true);
  };

  const OnClearSearch = (e) => {
    let _name = Helper.ToString(search.name);
    let _filter = Helper.ToString(search.filter);
    if (e === "filter") {
      setSearch({ name: _name, filter: 0 });
    } else if (e === "name") {
      setSearch({ name: null, filter: _filter });
    } else if (e === "ALL") {
      setSearch({ name: null, filter: 0 });
    }
    setDoSearch(true);
  };

  if (doSearch) {
    setDoSearch(false);
    OnFilterItems();
  }

  return (
    <>
      <Loader show={progress} />
      <div className="blk_container">
        <div className="head_blk">
          <div className="blkName">Users List</div>
          <Pagination
            refresh={refresh}
            pages={PageSize}
            onPageChanged={OnPageChanged}
          />
          <div className="head_right">
            <input
              type="text"
              placeholder="Search by Name"
              value={Helper.ToString(search.name)}
              onChange={(e) => OnSearchInputChanged("name", e.target.value)}
            />
            <input
              type="button"
              className="searchicon"
              onClick={() => onSearchClicked()}
            />
          </div>
          <div className="head_right">
            <select
              name="filterStatus"
              required
              value={Helper.ToString(search.filter)}
              onChange={(e) => OnSearchInputChanged("filter", e.target.value)}
            >
              {statustypes &&
                statustypes.map((x, index) => {
                  return (
                    <option value={x.id} key={index}>
                      {x.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
        {showFilter && (
          <div className="filterBlock">
            {!Helper.IsNullValue(search.name) && (
              <div className="filter">
                <b>Name / Entity:</b> {search.name}
                <div className="closeicon">
                  <Link
                    to="#"
                    title="Close"
                    onClick={(e) => OnClearSearch("name")}
                  >
                    &#215;
                  </Link>
                </div>
              </div>
            )}
            {Helper.ToInteger(search.filter) > 0 && (
              <div className="filter">
                <b>Status:</b>
                {filtername}
                <div className="closeicon">
                  <Link
                    to="#"
                    title="Close"
                    onClick={(e) => OnClearSearch("filter")}
                  >
                    &#215;
                  </Link>
                </div>
              </div>
            )}
            {!Helper.IsNullValue(search.name) &&
              Helper.ToInteger(search.filter) > 0 && (
                <input
                  type="button"
                  className="button_clear"
                  style={{ marginLeft: 2 }}
                  value="Clear All"
                  onClick={(e) => OnClearSearch("ALL")}
                />
              )}
          </div>
        )}
        <div className="contentarea_table">
          <div className="personaTable_head">
            <table>
              <tbody>
                <tr>
                  <td>
                    <Link to="#">Name</Link>
                  </td>
                  <td>Email Id</td>
                  <td>
                    <Link to="#">Entity</Link>
                  </td>
                  <td>Status</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>

          {rows && rows.length > 0 ? (
            <div className="personaTable">
              <table>
                <tbody>
                  {rows.map((x, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Link to="#">
                            {Helper.GetStringJoin(x, [
                              "first_name",
                              "last_name",
                            ])}
                          </Link>
                        </td>
                        <td>{x.email}</td>
                        <td>{x.display_name}</td>
                        <td>{x.statusname}</td>
                        <td>&nbsp;</td>
                        <td>{RenderButtonControl(x)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="noContent">No users are available</div>
          )}
        </div>
      </div>
    </>
  );
};

export default RenderPersonaListComponent;
